import React, { FC } from "react";
import { FormattedDate, FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";

import { useChatConversationById, useChatUserById } from "~/queries";
import { Icon, LoadingIcon } from "~/ui/components/icons";
import { useChatAuthAccessToken, useChatSettings } from "~/ui/context";

const Owner: React.FC<{ id: number }> = ({ id }) => {
  const { data: user } = useChatUserById(id);
  const { push } = useHistory();
  const { setIsChatOpen } = useChatSettings();

  const openProfile = () => {
    if (user) {
      push(`/user/${user.username}`);
      setIsChatOpen(false);
    }
  };
  return (
    <p
      className="text-bold text-uppercase text-overflow-el pointer"
      onClick={openProfile}
    >
      {user?.display_name ?? ""}
    </p>
  );
};

export const Details: FC<{
  chatId: number;
  onClose: () => void;
}> = ({ onClose, chatId }) => {
  const accessToken = useChatAuthAccessToken();
  const { data: conversationDetails, isLoading } = useChatConversationById(
    accessToken,
    chatId
  );

  return isLoading ? (
    <div className="pd-l-md pd-t-md h-min-200px flex justify-center items-center">
      <LoadingIcon size="2x" />
    </div>
  ) : (
    <div className="bg-light">
      <div className="flex justify-between items-center pd-b-sm border-bottom w-100">
        <h6 className="font-variant-small-caps pd-l-md mg-t-sm">
          <FormattedMessage defaultMessage="Details" id="Lv0zJu" />
        </h6>
        <Icon
          onClick={onClose}
          icon={["fal", "times"]}
          size="lg"
          className="pd-t-sm pd-r-sm pointer"
        />
      </div>

      <div className="flex flex-col pd-sm">
        <div className="flex items-center w-100 justify-between">
          <p className="overline-label">
            <FormattedMessage defaultMessage="Members" id="+a+2ug" />:
          </p>
          <p className="text-bold text-uppercase">
            {conversationDetails?.member_count}
          </p>
        </div>
        <div className="flex items-center w-100 justify-between">
          <p className="overline-label">
            <FormattedMessage defaultMessage="Date" id="P7PLVj" />:
          </p>
          <p className="text-bold text-uppercase">
            <FormattedDate
              value={conversationDetails?.created_at}
              day="2-digit"
              month="2-digit"
              year="numeric"
            />
          </p>
        </div>
        <div className="flex items-center w-100 justify-between gap-md">
          <p className="overline-label">
            <FormattedMessage defaultMessage="owner" id="7zGkrv" />:
          </p>

          {conversationDetails?.created_by_id && (
            <Owner id={conversationDetails?.created_by_id} />
          )}
        </div>

        {conversationDetails?.description && (
          <div className="flex flex-col w-100 justify-between">
            <p className="overline-label">
              <FormattedMessage defaultMessage="Description" id="Q8Qw5B" />:
            </p>
            <span className="text-bold text-uppercase">
              {conversationDetails?.description}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
